import type { SelectHTMLAttributes } from 'react'

interface Option {
  value: string
  label: string
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string
  error?: string
  options: Option[]
  placeholder?: string
}

export function Select({ label, error, options, placeholder, id, className = '', ...rest }: SelectProps) {
  const selectId = id ?? label?.toLowerCase().replace(/\s+/g, '-')

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={selectId} className="text-sm font-medium text-slate-700 dark:text-slate-300">
          {label}
        </label>
      )}
      <select
        id={selectId}
        {...rest}
        className={[
          'w-full rounded-lg border border-slate-300 bg-white text-slate-900 text-sm',
          'px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent',
          'dark:bg-slate-800 dark:border-slate-600 dark:text-slate-100',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          error ? 'border-danger focus:ring-danger' : '',
          className,
        ].join(' ')}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && <p className="text-xs text-danger">{error}</p>}
    </div>
  )
}
